var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m158.339 233.445c-.293 23.038-18.456 41.555-40.76 41.555-22.306 0-40.469-18.517-40.761-41.555 0-5.13 4.026-9.289 8.993-9.289s8.993 4.159 8.993 9.29c-.292 8.597 3.982 16.673 11.145 21.061a22.154 22.154 0 0 0 23.237 0c7.163-4.388 11.437-12.464 11.145-21.062v-222.895c-.091-3.38 1.602-6.543 4.42-8.26a8.747 8.747 0 0 1 9.139 0c2.819 1.717 4.512 4.88 4.42 8.26v222.896h.029z",
  stroke: "#003a70",
  strokeWidth: 1.882
}), /*#__PURE__*/React.createElement("path", {
  d: "m300.993 145.557c-5.799-66.128-66.206-118.72-141.483-122.637h-18.027c-75.227 3.91-135.6 56.423-141.483 122.478 7.315-5.406 18.414-8.853 30.84-8.853 19.34 0 35.458 8.354 39.101 19.432h1.608c3.734-11.006 19.803-19.287 39.06-19.287 4.48-.007 8.95.463 13.338 1.402 12.783 2.89 22.464 9.64 25.188 17.914h1.607c2.808-8.274 12.573-14.995 25.42-17.835.435-.1.891-.173 1.334-.267a63.484 63.484 0 0 1 12.313-1.214c1.72 0 3.405.08 5.068.21v-.181c17.298 1.178 31.247 9.047 34.602 19.258h1.608c3.735-11.006 19.804-19.287 39.06-19.287 12.44 0 23.538 3.454 30.853 8.867",
  fill: "#ff4438",
  fillRule: "nonzero"
}));
var SvgUmbrella = function SvgUmbrella(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 276,
    viewBox: "0 0 301 276",
    width: 301,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUmbrella, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Umbrella.79c4d32e.svg";
export { ForwardRef as ReactComponent };